import store from "../../../store/store";
import constants from "../../../utils/constants";
import axios from "../../axios";
// Token Refresh
let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function onAccessTokenFetched(access_token) {
	subscribers = subscribers.filter(callback => callback(access_token));
}

function addSubscriber(callback) {
	subscribers.push(callback);
}

export default {
	getAllCustomes(payload) {
		return axios.post(constants.API.CUSTOMERS.ALL, payload);
	},
	getCustomerV1List(payload) {
		return axios.post(constants.API.CUSTOMERS.V1_LIST, payload);
	},
	getCustomerList(payload) {
		return axios.post(constants.API.CUSTOMERS.LIST, payload);
	},
	getCustomer(id) {
		return axios.get(`${constants.API.CUSTOMERS.GET_CUSTOMER}${id}`);
	},
	createCustomer(payload) {
		return axios.post(`${constants.API.CUSTOMERS.CREATE_CUSTOMER}`, payload);
	},
	updateCustomer(id, payload) {
		return axios.put(`${constants.API.CUSTOMERS.UPDATE_CUSTOMER}${id}`, payload);
	},
	deleteCustomer(id) {
		return axios.delete(`${constants.API.CUSTOMERS.DELETE_CUSTOMER}${id}`);
	},
	deleteCustomerV2(payload) {
		return axios.post(constants.API.CUSTOMERS.DELETE_CUSTOMER_V2, payload);
	},
	exportData(payload) {
		return axios.post(`${constants.API.CUSTOMERS.EXPORT_YIELD}${payload}`, payload);
	},
	exportCustomerData(payload) {
		return axios.post(`${constants.API.CUSTOMERS.EXPORT}${payload}`, payload);
	},
	exportRawPondData(payload) {
		return axios.post(`${constants.API.CUSTOMERS.EXPORT_RAW_POND}${payload}`, payload);
	}
};
